<div class="payments-page">
  <header class="page-header">
    <h1>Zahlungen &amp; Abonnements</h1>
    <p>
      Verwalten Sie Ihre Lizenz bequem online. Wählen Sie das passende Paket und schließen Sie den Kauf sicher über Stripe ab.
    </p>
  </header>

  <section class="stripe-hint" *ngIf="!stripeConfigured">
    <mat-icon color="warn">info</mat-icon>
    <div>
      <h2>Stripe ist noch nicht eingerichtet</h2>
      <p>
        Hinterlegen Sie Ihren Stripe Publishable Key in der <code>environment</code>-Konfiguration, um Zahlungen zu aktivieren,
        oder kontaktieren Sie unser Vertriebsteam.
      </p>
    </div>
  </section>

  <section class="status-card" *ngIf="statusLoading || paymentStatus">
    <div class="status-card__header">
      <div class="status-card__title">
        <mat-icon>verified_user</mat-icon>
        <div>
          <div class="label">Aktueller Plan</div>
          <div class="value">{{ getPlanDisplayName(paymentStatus) || 'Lade Status...' }}</div>
        </div>
      </div>
      <mat-progress-spinner
        *ngIf="statusLoading"
        diameter="18"
        mode="indeterminate"
        strokeWidth="3"
      ></mat-progress-spinner>
    </div>

    <div class="status-card__body" *ngIf="paymentStatus">
      <span
        class="pill"
        [class.pill--active]="paymentStatus.active"
        [class.pill--inactive]="paymentStatus.active === false"
      >
        {{ paymentStatus.status || (paymentStatus.active ? 'aktiv' : 'nicht aktiv') }}
      </span>
      <span class="meta" *ngIf="paymentStatus.nextPaymentDate">
        N?chste Zahlung: {{ paymentStatus.nextPaymentDate | date: 'mediumDate' }}
      </span>
      <span class="meta" *ngIf="paymentStatus.subscriptionId">Subscription ID: {{ paymentStatus.subscriptionId }}</span>
    </div>
  </section>

  <section class="error-message" *ngIf="statusError">
    <mat-icon color="warn">warning</mat-icon>
    <span>{{ statusError }}</span>
  </section>

  <section class="plan-grid">
    <article
      class="plan-card"
      *ngFor="let plan of plans"
      [class.plan-card--recommended]="plan.recommended"
      [attr.aria-label]="plan.title + ' Tarif'"
    >
      <div class="plan-card__badge" *ngIf="plan.recommended">Beliebt</div>
      <h2 class="plan-card__title">{{ plan.title }}</h2>
      <p class="plan-card__subtitle">{{ plan.subtitle }}</p>

      <div class="plan-card__price">
        <span class="plan-card__price-value">{{ plan.price }}</span>
        <span class="plan-card__price-note" *ngIf="plan.priceNote">{{ plan.priceNote }}</span>
      </div>

      <button
        class="plan-card__cta btnPrimary"
        [ngClass]="plan.id === 'enterprise' ? 'ghost' : (plan.recommended ? 'strong' : 'light')"
        type="button"
        (click)="startCheckout(plan)"
        [disabled]="loadingPlanId === plan.id"
      >
        <mat-progress-spinner
          *ngIf="loadingPlanId === plan.id"
          diameter="18"
          mode="indeterminate"
          strokeWidth="3"
        ></mat-progress-spinner>
        <span *ngIf="loadingPlanId !== plan.id">{{ plan.ctaPrimary }}</span>
        <span class="visually-hidden" *ngIf="loadingPlanId === plan.id">Weiterleitung zu Stripe wird vorbereitet</span>
      </button>

      <ul class="plan-card__feature-list">
        <li *ngFor="let feature of plan.features">
          <mat-icon>check</mat-icon>
          <span>{{ feature }}</span>
        </li>
      </ul>

      <div class="plan-card__addons" *ngIf="plan.addOns?.length">
        <h3>{{ plan.addOnsTitle }}</h3>
        <ul>
          <li *ngFor="let addon of plan.addOns">{{ addon }}</li>
        </ul>
      </div>

      <div class="plan-card__contact-hint" *ngIf="!plan.stripePriceId">
        <mat-icon>support_agent</mat-icon>
        <span>Unser Team begleitet Sie persönlich bei der Vertragsgestaltung.</span>
      </div>
    </article>
  </section>

  <section class="stripe-explanation">
    <h2>Sicher zahlen mit Stripe</h2>
    <ol>
      <li>Wählen Sie Ihr Paket und klicken Sie auf den Stripe-Button.</li>
      <li>Wir erstellen automatisch eine sichere Stripe Checkout Session.</li>
      <li>Sie geben Ihre Zahlungsdaten direkt bei Stripe ein – wir speichern keine Zahlungsinformationen.</li>
      <li>Nach der erfolgreichen Zahlung werden Sie zurück in das Mitgliederportal geleitet.</li>
    </ol>

    <p>
      Sie möchten vorab testen? Nutzen Sie die
      <a href="https://stripe.com/docs/testing" rel="noopener" target="_blank">Stripe Testkarten</a>
      und prüfen Sie Ihre Abläufe in Ruhe.
    </p>
  </section>

  <section class="error-message" *ngIf="errorMessage">
    <mat-icon color="warn">warning</mat-icon>
    <span>{{ errorMessage }}</span>
  </section>
</div>
